import { render, staticRenderFns } from "./popStatDetail.vue?vue&type=template&id=72c8e492&scoped=true"
import script from "./popStatDetail.vue?vue&type=script&lang=js"
export * from "./popStatDetail.vue?vue&type=script&lang=js"
import style0 from "./popStatDetail.vue?vue&type=style&index=0&id=72c8e492&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c8e492",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-OA/jh-oa-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72c8e492')) {
      api.createRecord('72c8e492', component.options)
    } else {
      api.reload('72c8e492', component.options)
    }
    module.hot.accept("./popStatDetail.vue?vue&type=template&id=72c8e492&scoped=true", function () {
      api.rerender('72c8e492', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/assetManagement/common/popStatDetail.vue"
export default component.exports